import go from 'gojs';
import base64 from 'react-native-base64';
import Cookies from 'universal-cookie';
import { writeDebug } from '../../../components/common/logger';
import { getElementAttrib, getElementVal } from '../../almightyElementWrapper';
import { apiPost, getHostApi } from '../../apiWrapper';
import { isNullOrUndefined, tryParseInt, updateObject } from "../../storeFunctions";
import { GRAPH_TYPE, LOAD_TYPE, _name } from "../common/constants";
import { _eventLoggerSend, _formatDate, _handleError, _parseDate, _setCookie, _unique } from '../common/functions';
import { _checkLoadConditions, _fitDiagram, _load, _raiseDataChanged } from '../diagram/actions';
import { diagram } from '../diagram/initial';
import { LayeredTreeLayout } from '../diagram/templates/LayeredTreeLayout';
import { _resetExportButtons } from '../exports/actions';
import { _allRelationTypesChecked, _allWarningTypesChecked, _changeLevel, _findRelChilds, leftPanelActions } from '../leftPanel/actions';
import { tooltipsActions } from '../tooltips/actions';
import { DEFAULT_GRAPH_TYPE } from './initial';

// KEYS
const actions = {
    TOP_PANEL: { _name: _name + '_TOP_PANEL' },
    PROFILE_UPDATE: _name + '_PROFILE_UPDATE',
};
actions.TOP_PANEL = Object.assign(actions.TOP_PANEL, {
    TOGGLE: actions.TOP_PANEL._name + '_TOGGLE'
});

// MAP
const actionMap = {
    [`${actions.TOP_PANEL.TOGGLE}`]: (state, data) => updateObject(state, { topPanel: updateObject(state.topPanel, data) }),
    [`${actions.PROFILE_UPDATE}`]: (state, data) => updateObject(state, { profiles: updateObject(state.profiles, data) }),
}

// ACTIONS
const chartActions = {
    toggleTopPanel: (expanded) => async (dispatch) => dispatch({ type: actions.TOP_PANEL.TOGGLE, data: { expanded } }),
    updateTopPanelHeight: (w, h) => async (dispatch) => dispatch({ type: actions.TOP_PANEL.TOGGLE, data: { height: h } }),
    // TOP MENU
    changeZoom: (type) => async (dispatch) => {
        var oldScale = Math.round(diagram.nodeDiagram.scale * 100);
        var userScale = parseInt(document.getElementById('zoomTextBox').value || 100);
        dispatch({ type: tooltipsActions.LINK_TOOLTIP.HIDE });
        dispatch({ type: tooltipsActions.NODE_TOOLTIP.HIDE });
        dispatch({ type: tooltipsActions.COMMON_TOOLTIP.HIDE });

        switch (type) {
            case 'fit': _fitDiagram(); break;
            case 'up':
                if (oldScale % 5 === 0) {
                    diagram.nodeDiagram.scale = (oldScale + 5) / 100;
                } else {
                    diagram.nodeDiagram.scale = (Math.ceil(oldScale / 5) * 5) / 100;
                }
                break;
            case 'down':
                if (oldScale % 5 === 0) {
                    diagram.nodeDiagram.scale = (oldScale - 5) / 100;
                } else {
                    diagram.nodeDiagram.scale = (Math.floor(oldScale / 5) * 5) / 100;
                }
                break;
            case 'exact':
                if (userScale === '' || userScale <= 5) {
                    document.getElementById('zoomTextBox').value = "5%"
                    userScale = 5;
                }
                diagram.userScaleInput = true;
                diagram.nodeDiagram.scale = userScale / 100;
                break;
            case '100': diagram.nodeDiagram.scale = 1; break;
            case 'root':
                let i = 0;
                diagram.nodeDiagram.findTreeRoots().each(function (n) {
                    if (n instanceof go.Node) {
                        if (i === 0) {
                            diagram.nodeDiagram.scale = 0.7;
                            diagram.nodeDiagram.centerRect(n.actualBounds);
                            i += 1;
                        }
                    }
                });
                break;
            case 'selected':
                let j = 0;
                diagram.nodeDiagram.selection.each(function (n) {
                    if (n instanceof go.Node) {
                        if (j === 0) {
                            diagram.nodeDiagram.scale = 0.7;
                            diagram.nodeDiagram.centerRect(n.actualBounds);
                            j += 1;
                        }
                    }
                });
                break;
            default:
                break;
        }
    },
    changeGraphType: (e) => async (dispatch) => {
        const graphType = e.currentTarget.getAttribute('group-value') || 'star';
        _setGraphType(dispatch, graphType);
    },
    toggleOverview: () => async () => {
        const value = !document.getElementById('overviewToggle').classList.contains('checked');
        _toggleOverview(value);
    },
    toggleMagnifier: () => async () => {
        const value = !document.getElementById('magnifierToggle').classList.contains('checked');
        _toggleMagnifier(value)
    },
    toggleRelationLabels: () => async (dispatch) => {
        const el = document.querySelector('#relationLabelsCheckbox');
        _toggleRelationLabels(dispatch, el.checked = !el.checked);
    },
    toggleProfiVersion: () => async (dispatch,) => {
        const el = document.querySelector('#profiVersionNiCheckboxViewer');
        _toggleProfiVersion(dispatch, el.checked = !el.checked)
    },
    useProfile: () => async (dispatch, getState) => {
        _checkLoadConditions(
            getState,
            () => {
                const profileName = getElementVal('#profileSelector');
                _eventLoggerSend('profileLoad', profileName);
                var cookieString = (getState().charts.profiles[profileName] || {}).data;
                _useProfile(dispatch, getState, cookieString, () => _load(dispatch, getState, LOAD_TYPE.common));
            }
        );
    },
    saveProfile: () => async (_, getState) => {
        const profileName = getElementVal('#profileSelector');
        _eventLoggerSend('profileSave', profileName);
        const cookieString = _createCookieString(getState);
        let profile = getState().charts.profiles[profileName];
        if (profile == null || profile === undefined) {
            writeDebug('profile name not matched')
        } else {
            profile.data = cookieString.join('|');
        }

        apiPost(`${getHostApi()}/api/charts/user-profile`, undefined, { name: profileName, data: base64.encode(cookieString.join('|')) },
            _ => writeDebug('/api/charts/user-profile success'),
            e => _handleError('/api/charts/export/user-profile error', e, getState),
        );
    },
    renameProfile: (newName) => async (dispatch, getState) => {
        const profileName = getElementVal('#profileSelector');
        var _profiles = getState().charts.profiles;
        _profiles[profileName].label = newName;

        apiPost(`${getHostApi()}/api/charts/user-profile-rename`, undefined, { oldName: profileName, newName: newName },
            () => dispatch({ type: actions.PROFILE_UPDATE, data: _profiles }),
            e => _handleError('/api/charts/export/user-profile-rename error', e, getState),
        );
    },
}

// FUNCTIONS
function _getGraphType() {
    const graphType = getElementAttrib('#typeController a[group="types"].checked', 'group-value');
    return graphType || DEFAULT_GRAPH_TYPE;
}

function _setGraphType(dispatch, type, isVisualization = false) {
    if (type !== '' && !isNullOrUndefined(type) && Object.values(GRAPH_TYPE).indexOf(type) !== -1) {
        dispatch({ type: actions.TOP_PANEL.TOGGLE, data: { graphType: type } });
        _setCookie("TypeController", type);
        _changeLayout(type, isVisualization);
    }
}

function _changeLayout(type, isVisualization = false) {
    diagram.nodeDiagram.startTransaction("toggleLayout");
    switch (type) {
        case GRAPH_TYPE.oriented:
            if (diagram._relationsOriented)
                diagram.nodeDiagram.model.linkDataArray = diagram._relationsOriented;
            break;
        default:
            if (diagram._relations)
                diagram.nodeDiagram.model.linkDataArray = diagram._relations;
            break;
    }
    diagram.nodeDiagram.layout = _getLayout(type);
    _notifyTypeChanged(type);
    diagram.nodeDiagram.commitTransaction("toggleLayout");
    _eventLoggerSend('graphType', type);

    if (!isVisualization)
        diagram.nodeDiagram.layoutDiagram(true);
    _fitDiagram();

    diagram.nodeDiagram.contentAlignment = go.Spot.Center;
    document.getElementById('zoomTextBox').value = Math.round(diagram.nodeDiagram.scale * 100) + "%";
}

function _getLayout(type) {
    switch (type) {
        case GRAPH_TYPE.star:
            return go.GraphObject.make(go.ForceDirectedLayout,
                {
                    defaultElectricalCharge: 800,
                    maxIterations: 400,
                    defaultGravitationalMass: 200,
                    defaultSpringStiffness: 0.05,
                    defaultSpringLength: 50,
                    infinityDistance: 1000,
                    epsilonDistance: 1,
                    isInitial: false,
                    isOngoing: false,
                });
        case GRAPH_TYPE.tree:
        case GRAPH_TYPE.oriented:
            return go.GraphObject.make(LayeredTreeLayout, {
                arrangement: go.TreeLayout.ArrangementHorizontal,
                angle: 90,
                childPortSpot: go.Spot.TopBottomSides,
                portSpot: go.Spot.TopBottomSides,
                layerSpacing: 400,
                sorting: go.TreeLayout.SortingAscending,
                comparer: function (a, b) {

                    // A and B are TreeVertexes
                    var av = a.node.data.Name;
                    var bv = b.node.data.Name;
                    return av.localeCompare(bv);
                },
                isInitial: false,
                isOngoing: false,
            });
        case GRAPH_TYPE.branch:
            return go.GraphObject.make(LayeredTreeLayout,
                {
                    childPortSpot: go.Spot.LeftRightSides,
                    portSpot: go.Spot.LeftRightSides,
                    layerSpacing: 400,
                    sorting: go.TreeLayout.SortingAscending,
                    comparer: function (a, b) {

                        // A and B are TreeVertexes
                        var av = a.node.data.Name;
                        var bv = b.node.data.Name;
                        return av.localeCompare(bv);
                    },
                    isInitial: false,
                    isOngoing: false,
                });
        default:
            return go.Layout();
    }
}

function _notifyTypeChanged(newVal) {
    for (let i = 0; i < diagram.nodeDiagram.model.linkDataArray.length; i++) {
        _raiseDataChanged(diagram.nodeDiagram.model.linkDataArray[i], "GraphType", newVal);
    }
    for (let i = 0; i < diagram.nodeDiagram.model.nodeDataArray.length; i++) {
        _raiseDataChanged(diagram.nodeDiagram.model.nodeDataArray[i], "Level", (newVal === GRAPH_TYPE.oriented) ? diagram.nodeDiagram.model.nodeDataArray[i].OrientedLevel : diagram.nodeDiagram.model.nodeDataArray[i].OriginalLevel);
        _raiseDataChanged(diagram.nodeDiagram.model.nodeDataArray[i], "GraphType", newVal);
    }
}

function _toggleToolIcon(elementId, state) {
    let target = document.getElementById(elementId);
    if (target) {
        if (!state) {
            target.classList.remove('checked');
        } else {
            target.classList.add('checked');
        }
    }
}

function _toggleOverview(state) {
    _toggleToolIcon('overviewToggle', state);
    _eventLoggerSend('navigationWindow', state ? 'on' : 'off');

    const over = document.querySelector('#overviewDivWindow');
    if (state) {
        let ow = document.querySelector('#myOverview');
        if (ow.getAttribute('overview-initialized') !== 'true') {
            ow = go.GraphObject.make(go.Overview, ow, { observed: diagram.nodeDiagram, contentAlignment: go.Spot.Center });
            ow.box.elt(0).stroke = "#f58228";
            ow.box.elt(0).strokeWidth = 2;

            document.querySelector('#myOverview').setAttribute('overview-initialized', 'true')
        }
        over.style.display = '';
    } else {
        over.style.display = 'none';
    }
}

function _toggleMagnifier(state) {
    _toggleToolIcon('magnifierToggle', state);
    _eventLoggerSend('magnifierWindow', state ? 'on' : 'off');

    const magnifierDiv = document.querySelector("#magnifierDivWindow");
    if (state) {
        magnifierDiv.setAttribute('magnifier-active', 'true');
        diagram.nodeDiagram.allowSelect = false;

        if (document.querySelector('#myMagnifier').getAttribute('magnifier-initialized') !== 'true') {
            let mag = go.GraphObject.make(go.Overview, document.querySelector('#myMagnifier'), {
                observed: diagram.nodeDiagram, initialScale: 1, autoScale: go.Diagram.None, hasHorizontalScrollbar: false,
                hasVerticalScrollbar: false, fixedBounds: new go.Rect(-30000, -30000, 30000, 30000)
            });
            mag.box.elt(0).stroke = "black";
            _configureMagnifier(mag);
            diagram.nodeMagnifier = mag;
            document.querySelector('#myMagnifier').setAttribute('magnifier-initialized', true);
        }
    } else {
        magnifierDiv.setAttribute('magnifier-active', 'false');
        magnifierDiv.style.display = 'none';
        diagram.nodeDiagram.allowSelect = true;
    }
}

function _configureMagnifier(mag) {
    document.querySelector('#magnifierDivWindow').onmouseleave = function (e) {
        if (!e.toElement.is('canvas')) {
            document.querySelector("#magnifierDivWindow").style.display = 'none';
        }
    };
    document.querySelector('#diagramPlane').onmouseenter = function (e) {
        if (document.querySelector('#magnifierDivWindow').getAttribute('magnifier-active') === 'true') {
            document.querySelector("#magnifierDivWindow").style.display = '';
        }
    };

    mag.toolManager.mouseDownTools.each(function (t) { t.isEnabled = false; });

    // handle mouse moves within the magnifier by redirecting the events to the window.myDiagram
    mag.toolManager.doMouseMove = function () {
        // forward mouse move object to main diagram
        diagram.nodeDiagram.lastInput.event = mag.lastInput.event;
        var posLeft = document.querySelector('#diagramPlane').offsetLeft;
        var posTop = document.querySelector('#diagramPlane').offsetTop;

        diagram.nodeDiagram.lastInput.documentPoint = diagram.nodeDiagram.transformViewToDoc(new go.Point(mag.lastInput.event.clientX - posLeft, mag.lastInput.event.clientY - posTop));
        diagram.nodeDiagram.toolManager.doMouseMove();
    };

    mag.addDiagramListener('ObjectSingleClicked', function (e, obj) {
        if (diagram._noConflictGoBtnClick === undefined || diagram._noConflictGoBtnClick == null) {
            return;
        }
        var event = diagram._noConflictGoBtnClick;

        if (diagram._noConflictGoBtnReleaseAfterExec !== undefined && diagram._noConflictGoBtnReleaseAfterExec === true) {
            diagram._noConflictGoBtnClick = null;
        }
        // execute in parallel to not block UI
        setTimeout(function () { event(e.diagram.lastInput); }, 0);

        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
    });
}

function _getRelationLabelsChecked() {
    return document.querySelector('input#relationLabelsCheckbox[type="checkbox"]').checked;
}

function _toggleRelationLabels(dispatch, val) {
    if (val !== '' && !isNullOrUndefined(val) && (val === 'true' || val === true || val === 'false' || val === false)) {
        _toggleLinkLabels(val);
        dispatch({ type: actions.TOP_PANEL.TOGGLE, data: { linkLabels: val } });
        _setCookie("RelationCaptionDisplay", val);
        _resetExportButtons(dispatch);
    }
}

function _toggleLinkLabels(val) {
    diagram.nodeDiagram.links.each(function (value) {
        var label = value.findObject("label");
        if (label != null) {
            label.visible = val;
        }
    });
}

function _getProfiVersionChecked() {
    return document.querySelector('input#profiVersionNiCheckboxViewer[type="checkbox"]').checked;
}

function _toggleProfiVersion(dispatch, val) {
    if (val !== '' && !isNullOrUndefined(val) && (val === 'true' || val === true || val === 'false' || val === false)) {
        diagram.nodeDiagram.model.setDataProperty(diagram.nodeDiagram.model.modelData, "UseProfiWarnings", val);
        dispatch({ type: actions.TOP_PANEL.TOGGLE, data: { isProfi: val } });
        _setCookie("ProfiVersionNiDisplay", val);
        _resetExportButtons(dispatch);
    }
}

function _useProfile(dispatch, getState, cookieString, loadFunc, isVisualization = false) {
    try {
        if (cookieString == null || cookieString === undefined || cookieString === '')
            return;

        var items = cookieString.split('|');
        if (items.length === 0)
            return;

        var reloadGraph = false;
        items.forEach(function (item) {
            var parts = item.split(':');
            if (parts.length !== 2)
                return;

            var key = parts[0];
            var val = parts[1];
            switch (key) {
                case 'gt': {
                    const target = document.querySelector(`#typeController a.rc-checkbox[group-value="${val}"]`);
                    if (!target.classList.contains('checked') || isVisualization) {
                        _setGraphType(dispatch, val, isVisualization);
                    }
                    break;
                }
                case 'nw': {
                    const target = document.querySelector('#toolController a#overviewToggle.rc-checkbox');
                    if (target.classList.contains('checked') ^ (val === 'true')) {
                        _toggleOverview(val === 'true');
                    }
                    break;
                }
                case 'mag': {
                    const target = document.querySelector('#toolController a#magnifierToggle.rc-checkbox');
                    if (target.classList.contains('checked') ^ (val === 'true')) {
                        _toggleMagnifier(val === 'true');
                    }
                    break;
                }
                case 'lnk': {
                    const target = document.querySelector('input#relationLabelsCheckbox[type="checkbox"]');
                    if (target.checked ^ (val === 'true') || isVisualization) {
                        _toggleRelationLabels(dispatch, target.checked = val === 'true' || val === true)
                    }
                    break;
                }
                case 'profi': {
                    const target = document.querySelector('input#profiVersionNiCheckboxViewer[type="checkbox"]');
                    if ((target.checked ^ (val === 'true')) || isVisualization) {
                        _toggleProfiVersion(dispatch, target.checked = val === 'true' || val === true);
                    }
                    break;
                }
                case 'lvl': {
                    if (diagram.diagramParams.level !== parseInt(val)) {
                        _changeLevel(dispatch, parseInt(val));
                        reloadGraph = true;
                    }
                    break;
                }
                case 'dir': {
                    if (diagram.diagramParams.direction !== parseInt(val)) {
                        dispatch({ type: leftPanelActions.LEFT_PANEL.TOGGLE, data: { linkDirection: parseInt(val) } });
                        diagram.diagramParams.direction = parseInt(val);
                        reloadGraph = true;
                    }
                    break;
                }
                case 'maj': {
                    const valParsed = val.split('_');
                    if (valParsed.length === 2) {
                        const shareChecked = valParsed[0] === 'true';
                        let shareValue = 50;
                        if (valParsed[1] != null) {
                            shareValue = tryParseInt(valParsed[1].replace('%', ''), 50);
                        }
                        diagram.diagramParams.sharePct = shareValue;
                        diagram.diagramParams.shareChecked = shareChecked;
                        dispatch({ type: leftPanelActions.LEFT_PANEL.TOGGLE, data: { shareChecked, shareValue } });
                        reloadGraph = true;
                    }
                    break;
                }
                case 'hist': {
                    const valParsed = val.split('_');
                    if (valParsed.length === 3) {
                        diagram.diagramParams.history = valParsed[0] === 'true';
                        if (valParsed[1] != null) {
                            diagram.diagramParams.dateFrom = _parseDate(valParsed[1]);
                        }
                        if (valParsed[2] != null) {
                            diagram.diagramParams.dateTo = _parseDate(valParsed[2]);
                        }
                        dispatch({ type: leftPanelActions.LEFT_PANEL.TOGGLE, data: { history: diagram.diagramParams.history, dateFrom: diagram.diagramParams.dateFrom, dateTo: diagram.diagramParams.dateTo } });
                        reloadGraph = true;
                    }
                    break;
                }
                case 'rt': {
                    const vals = val.split('_');
                    if (vals.length > 1 && (vals[0] === 'n' || val[0] === 'c')) {
                        const relType = getState().charts.domains.relationTypes;
                        if (vals[0] === 'n') {
                            diagram.diagramParams.rt = [];
                            for (let i = 0; i < relType.length; i++)
                                diagram.diagramParams.rt = diagram.diagramParams.rt.concat(_findRelChilds(relType[i]));
                            diagram.diagramParams.rt = diagram.diagramParams.rt.filter(function (f) { return vals.slice(1).indexOf(f) === -1 });
                            //backward compatibility
                            const values = vals.slice(1);
                            for (let i = 0; i < values.length; i++) {
                                if (values[i]) {
                                    diagram.diagramParams.rt = diagram.diagramParams.rt.filter(f => !f.startsWith(values[i]));
                                    if (values[i].length > 4)
                                        for (let j = 4; j < values[i].length; j += 2)
                                            diagram.diagramParams.rt = diagram.diagramParams.rt.filter(f => f !== values[i].substring(0, j));
                                }
                            }
                        }
                        else {
                            const values = vals.slice(1);
                            //backward compatibility, otherwise vals.slice(1) is enought
                            let result = [];
                            let all = [];
                            for (let i = 0; i < relType.length; i++)
                                all = all.concat(_findRelChilds(relType[i]));
                            for (let i = 0; i < values.length; i++)
                                result = result.concat(all.filter(a => a.startsWith(values[i])));
                            diagram.diagramParams.rt = _unique(result);
                        }
                        const allChecked = _allRelationTypesChecked(getState);
                        dispatch({ type: leftPanelActions.LEFT_PANEL.TOGGLE, data: { rt: diagram.diagramParams.rt, relTypesAllChecked: allChecked.checked, relTypesAllPartial: allChecked.partial } });
                        reloadGraph = true;
                    }
                    break;
                }
                case 'wt': {
                    const vals = val.split('_');
                    if (vals.length > 1 && (vals[0] === 'n' || val[0] === 'c')) {
                        const warType = getState().charts.domains.warningTypes;
                        if (vals[0] === 'n') {
                            diagram.diagramParams.wt = [];
                            for (let i = 0; i < warType.length; i++)
                                diagram.diagramParams.wt = diagram.diagramParams.wt.concat(_findRelChilds(warType[i]));
                            diagram.diagramParams.wt = diagram.diagramParams.wt.filter(function (f) { return vals.slice(1).indexOf(f) === -1 });
                            //backward compatibility
                            const values = vals.slice(1);
                            for (let i = 0; i < values.length; i++) {
                                if (values[i]) {
                                    diagram.diagramParams.wt = diagram.diagramParams.wt.filter(f => !f.startsWith(values[i]));
                                    if (values[i].length > 4)
                                        for (let j = 4; j < values[i].length; j += 2)
                                            diagram.diagramParams.wt = diagram.diagramParams.wt.filter(f => f !== values[i].substring(0, j));
                                }
                            }

                        }
                        else {
                            const values = vals.slice(1);
                            //backward compatibility, otherwise vals.slice(1) is enought
                            let result = [];
                            let all = [];
                            for (let i = 0; i < warType.length; i++)
                                all = all.concat(_findRelChilds(warType[i]));
                            for (let i = 0; i < values.length; i++)
                                result = result.concat(all.filter(a => a.startsWith(values[i])));
                            diagram.diagramParams.wt = _unique(result);

                        }
                        const allChecked = _allWarningTypesChecked(getState);
                        dispatch({ type: leftPanelActions.LEFT_PANEL.TOGGLE, data: { wt: diagram.diagramParams.wt, warTypesAllChecked: allChecked.checked, warTypesAllPartial: allChecked.partial } });
                    }
                    break;
                }
                default:
                    break;
            }
        });

        if (loadFunc && (reloadGraph || isVisualization)) {
            loadFunc();
        }
    } catch (e) {
    }
}

function _createCheckboxesCookieContent(selected, domain) {
    var all = [];
    for (var i = 0; i < domain.length; i++)
        all = all.concat(_findRelChilds(domain[i]));
    var notChecked = all.filter(function (f) { return selected.indexOf(f) === -1 });

    if (selected.length > notChecked.length)
        return 'n_' + notChecked.join('_');
    else
        return 'c_' + selected.join('_');
}

function _createCookieString(getState) {
    const cookieString = []
    // TOP PANEL
    cookieString.push('gt:' + _getGraphType());
    cookieString.push('nw:' + document.querySelector('#toolController a#overviewToggle.rc-checkbox').classList.contains('checked'));
    cookieString.push('mag:' + document.querySelector('#toolController a#magnifierToggle.rc-checkbox').classList.contains('checked'));
    cookieString.push('lnk:' + _getRelationLabelsChecked());
    cookieString.push('profi:' + _getProfiVersionChecked());
    // LEFT PANEL
    cookieString.push('lvl:' + diagram.diagramParams.level);
    cookieString.push('dir:' + diagram.diagramParams.direction);
    cookieString.push('maj:' + diagram.diagramParams.shareChecked + '_' + diagram.diagramParams.sharePct);
    cookieString.push('hist:' + diagram.diagramParams.history + '_' + _formatDate(diagram.diagramParams.dateFrom) + '_' + _formatDate(diagram.diagramParams.dateTo));
    cookieString.push('rt:' + _createCheckboxesCookieContent(diagram.diagramParams.rt, getState().charts.domains.relationTypes));
    cookieString.push('wt:' + _createCheckboxesCookieContent(diagram.diagramParams.wt, getState().charts.domains.warningTypes));
    return cookieString;
}

function _processProfileData(data, dispatch, current) {
    let _profiles = {};
    data.names.forEach(n => _profiles[n.id] = { label: n.name, data: '' });

    if (data.data != null) {
        var progileList = data.data.split('|').filter(function (pd) { return pd !== null && pd.split('_').length === 2; });
        for (var i = 0; i < progileList.length; i++) {
            var splt = progileList[i].split('_')
            _profiles[splt[0]].data = base64.decode(splt[1]);
        }
    }

    var p1Test = new Cookies().get('profile_profile1');
    if (p1Test !== null && p1Test !== undefined && p1Test !== '') {
        if (_profiles.filter(prf => prf === 'profile1').length === 0) {
            _profiles['profile1'].data = p1Test;
        }
    }
    var p2Test = new Cookies().get('profile_profile2');
    if (p2Test !== null && p2Test !== undefined && p2Test !== '') {
        if (_profiles.filter(prf => prf === 'profile2').length === 0) {
            _profiles['profile2'].data = p2Test;
        }
    }
    dispatch({ type: actions.PROFILE_UPDATE, data: _profiles });
}

export {
    _changeLayout, _createCookieString, _getGraphType, _getLayout, _getProfiVersionChecked, _getRelationLabelsChecked, _processProfileData, _toggleLinkLabels, _toggleProfiVersion, _toggleToolIcon as _toogleTopPanelToolIcon, _useProfile, _toggleRelationLabels,
    actionMap as topPanelActionMap, actions as topPanelActions, chartActions as topPanelChartActions
};

